import { defineNuxtPlugin } from '#imports'
import { initEqualWeb } from './external-tools-client/equalweb'
import { initHubspot } from './external-tools-client/hubspot'

export default defineNuxtPlugin({
  name: 'external tools',
  parallel: true,
  hooks: {
    async 'app:mounted'() {
      initEqualWeb()
      await initHubspot()
    },
  },
})
